module.exports = __webpack_public_path__ + "static/media/barrel.2ad73b9a.svg";